import { createActionWithCallback } from 'core/store/utils';
import { SendStatus } from 'types';

export const fetchSendStatus = createActionWithCallback<SendStatus[], Error>()('fetchSendStatus');

export default { fetchSendStatus };
